import { useState, useContext } from "react";
import { UserContext } from "../context/UserContext";
import { AlertContext } from "../context/AlertContext";
import { useNavigate } from "react-router-dom";
import API from "../api/api";

import "../css/auth.css"; // IMPORTANTE 🔥

const Login = () => {
  const userContext = useContext(UserContext);
  const alertContext = useContext(AlertContext);
  const navigate = useNavigate();

  const login = userContext?.login;
  const showAlert = alertContext?.showAlert;

  const [nombre, setNombre] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!login || !showAlert) return;

    try {
      const res = await API.post("/auth/login", { nombre, password });

      localStorage.setItem("token", res.data.token);

      login(res.data.user, res.data.token);
      showAlert(`Bienvenido ${nombre} ⚽🔥`, "success");
      navigate("/");

    } catch {
      showAlert("Usuario o contraseña incorrectos", "error");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Iniciar Sesión</h2>

        <form onSubmit={handleLogin}>
          <input
            placeholder="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />

          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit">Ingresar</button>
          <p className="auth-link">
            ¿No tenés cuenta?{" "}
            <span onClick={() => navigate("/register")}>
              Registrate acá
            </span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
